import { Texture } from './Texture';
import { Polyline } from './Polyline';
import { SpriteBatch } from './SpriteBatch';
import { SpriteVertex } from './SpriteVertex';
import { Matrix3 } from './Matrix3';

export class PolylineRenderer {
  texture: Texture;
  polyline: Polyline;

  draw(spriteBatch: SpriteBatch, vertices: Array<SpriteVertex>, transform: Matrix3): void {
    spriteBatch.drawSpriteVertices(this.texture, vertices, transform);
  }
}
